export default "__VITE_ASSET__DrM$qD88__"